import Head from 'next/head';
import ScheduleYourCallFormContext
  from '@/evercall/application/scheduleYourCallForm/ScheduleYourCallFormContext';

import Intro from './Intro';
import Form from './Form';
import OurCommitment from './OurCommitment';

const ScheduleYourCall = () => (
  <ScheduleYourCallFormContext>
    <Head>
      <title>Schedule Your Call | Evercall</title>
      <meta
        name="description"
        content="Schedule your call in minutes by filling out a simple form."
      />
    </Head>
    <Intro />
    <Form />
    <OurCommitment />
  </ScheduleYourCallFormContext>
);

export default ScheduleYourCall;
